import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-consignee-details-box',
  standalone: true,
  imports: [],
  templateUrl: './consignee-details-box.component.html',
  styleUrl: './consignee-details-box.component.scss'
})
export class ConsigneeDetailsBoxComponent {
  @Input()
  consigneeDetails: any;
}
